import { Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { EditorLayout } from '@/layouts/EditorLayout';
import { ManagerArticle } from '@/pages/editor/ManagerArticle';
import { ArticleSummaryReview } from '@/pages/editor/ArticleSummaryReview';
import { ExtractedWordsReview } from '@/pages/editor/ExtractedWordsReview';
import { TranslationReview } from '@/pages/editor/TranslationReview';
import TtsReview from '@/pages/editor/TtsReview';
import { PublishArticle } from '@/pages/editor/PublishArticle';
import { BatchArticleCreate } from '@/pages/editor/BatchArticleCreate';
import { ArticlePlan } from '@/pages/editor/ArticlePlan';

export function EditorRouter() {
  return (
    <>
      {/* Editor routes */}
      <Route
        path="/editor/articles"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <ManagerArticle />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/create-batch"
        element={
          <ProtectedRoute roles={['admin']}>
            <EditorLayout>
              <BatchArticleCreate />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/plans"
        element={
          <ProtectedRoute roles={['admin']}>
            <EditorLayout>
              <ArticlePlan />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/translation/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <TranslationReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/translation/:country/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <TranslationReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/summary/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <ArticleSummaryReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/summary/:country/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <ArticleSummaryReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/extracted-words/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <ExtractedWordsReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/extracted-words/:country/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <ExtractedWordsReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/tts/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <TtsReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/tts/:country/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <TtsReview />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/publish/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <PublishArticle />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/articles/publish/:country/:id"
        element={
          <ProtectedRoute roles={['admin', 'editor']}>
            <EditorLayout>
              <PublishArticle />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
    </>
  );
}
